import { Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { EmployeeHodMappingService } from "./employee-mapping-service";
import { CommonResponseModel } from "@project-management-system/shared-models";

@Controller('employee_hod_mapping')
@ApiTags('/employee_hod_mapping')
export class employeeHodMappingController {
    constructor(private service:EmployeeHodMappingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
     ) { }

     @Post('/getAllEmployeeHod')

     async getEmployeeHod(): Promise<CommonResponseModel> {
      // console.log('contrillerkkkkk');
        try {
            return await this.service.getEmployeeHod();
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
     }
}